import config from "@/config"
import http from "@/utils/request"

export default {
	listCustomer: {
		url: `${config.API_URL}/lqa-game/system/project/customer/list`,
		name: "获取客户项目关系列表",
		get: async function(params){
			return await http.get(this.url, params);
		}
	},
  getCustomer: {
		url: `${config.API_URL}/lqa-game/system/project/customer/`,
		name: "获取客户项目关系",
		get: async function(params){
			return await http.get(this.url+params);
		}
	},
  getCustomChild:{
	url: `${config.API_URL}/lqa-game/system/project/customer/getCustomUser?projectNum=`,
		name: "获取客户项目关系",
		get: async function(param){
			return await http.get(this.url+param);
		}
  },
  getCustomChildUser:{
	url: `${config.API_URL}/lqa-game/system/project/customer/getCustomChild?projectNum=`,
		name: "获取客户项目关系",
		get: async function(param){
			return await http.get(this.url+param);
		}
  },
  addCustomer:{
		url: `${config.API_URL}/lqa-game/system/project/customer`,
		name: "提交客户项目关系",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
  updateCustomer:{
		url: `${config.API_URL}/lqa-game/system/project/customer`,
		name: "修改客户项目关系",
		put: async function(data){
			return await http.put(this.url, data);
		}
	},
  delCustomer:{
		url: `${config.API_URL}/lqa-game/system/project/customer/`,
		name: "删除客户项目关系",
		delete: async function(param){
			return await http.delete(this.url+param);
		}
	},
  exportCustomer:{
		url: `${config.API_URL}/lqa-game/system/project/customer/`,
		name: "导出客户项目关系",
		get: async function(query){
			return await http.get(this.url, query);
		}
	},

	getCustomerUser: {
		url: `${config.API_URL}/lqa-game/system/customer/user/byId?id=`,
		name: "获取客户项目关系",
		get: async function(params){
			return await http.get(this.url+params);
		}
	},
	addCustomerUsers:{
		url: `${config.API_URL}/lqa-game/system/customer/user/addUsers`,
		name: "获取客户项目关系",
		post: async function(data){
			return await http.post(this.url,data);
		}
	},
	delCustomerUsers:{
		url: `${config.API_URL}/lqa-game/system/customer/user/`,
		name: "获取客户项目关系",
		delete: async function(id){
			return await http.delete(this.url+id);
		}
	}
}
